import React, { useState, useEffect } from 'react';
import './ContactListCompo.css';
import { CSVLink } from "react-csv";
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '@mui/icons-material/Delete';
import { db } from '../lib/firebaseConfig';
import { collection, onSnapshot, deleteDoc, doc } from "firebase/firestore";

function ContactListCompo() {
  const [contacts, setContacts] = useState([]);

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, 'chatUsers'), (snapshot) => {
      const contactsData = snapshot.docs.map(doc => {
        const data = doc.data();
        const timestamp = data.timestamp ? data.timestamp.toDate().toLocaleString() : '';
        return {
          id: doc.id, // Ajout de l'ID du document Firebase au contact
          ...data,
          date: timestamp,
          ip: data.ip || '' // Ajout de l'adresse IP de l'utilisateur
        };
      });      
      setContacts(contactsData);
    });

    return () => {
      unsubscribe(); // Désabonnement lors du démontage du composant
    };
  }, []);

  const headers = [
    { label: "Name", key: "name" },
    { label: "Email", key: "email" },
    { label: "Number", key: "number" },
    { label: "Date", key: "date" }
  ];

  const handleRemove = async (index) => {
    const contact = contacts[index];

    try {
      // Supprimer le contact de Firebase
      await deleteDoc(doc(db, 'chatUsers', contact.id));
      console.log('Contact deleted successfully from Firebase');

      // Mettre à jour le state local en supprimant le contact
      const newContacts = [...contacts];
      newContacts.splice(index, 1);
      setContacts(newContacts);
    } catch (error) {
      console.error('Error deleting contact from Firebase:', error);
    }
  }

  return (
    <div className='ContactListCompo'>

      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>IP</th>
            <th>Date</th>
            <th style={{borderRight: 'none'}}>Delete</th>
          </tr>
        </thead>
        <tbody>
          {contacts.map((contact, index) => {
            if (!contact.name || !contact.email) {
              return null; // Ignorer la ligne si les champs requis sont vides
            }

            return (
              <tr key={index}>
                <td>{contact.name}</td>
                <td>{contact.email}</td>
                <td>{contact.ip}</td>
                <td>{contact.date}</td>
                <td style={{borderRight: 'none'}}><DeleteIcon style={{cursor: 'pointer'}} onClick={() => handleRemove(index)} /></td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <CSVLink data={contacts} headers={headers} filename={"contact-list.csv"} style={{marginLeft:'30px', position: 'absolute', bottom: '2%', right:'1%', borderRadius: '50px', fontSize: '14px', paddingLeft: '30px', paddingRight: '30px'}} className="download-btn">DOWNLOAD CSV <DownloadIcon/> </CSVLink >
    </div>
  )
}

export default ContactListCompo;
